import React from "react"
import CustomModal from "./modal"
import { BtnEvent } from "../api/EventTypes"
import { CheckBooleanField } from "./generic/form/CheckBooleanField"
import { FieldName } from "../common/text"
import { IFieldValues } from "../containers/selectionSlice"
import { formatDateShortwYear } from "./Utils"
import { TimeField } from "./selectorFields"
import DatePickerField from "./generic/form/DatePickerField"

export enum FieldType {
  DatePicker = "DatePicker",
  Time = "Time",
  CheckBoolean = "CheckBoolean"
}

interface DataEditPanelField {
  type: FieldType
  name: FieldName
  caption: string
  required?: boolean
}

interface Props {
  title: string
  CTAText: string
  fields: DataEditPanelField[]
  values: IFieldValues
  prevValues?: IFieldValues
  onFieldChange: (name: string, value: string, error: boolean) => void
  onCancel: () => void
  onCTAClick: () => void
  touched?: boolean
}

const DataEditPanel: React.FunctionComponent<Props> = ({
  title,
  CTAText,
  fields,
  values,
  prevValues,
  onCancel,
  onCTAClick,
  onFieldChange,
  touched
}) => {
  const panelFields = fields.map((field, idx) => {
    let panelField = null

    if (field.type === FieldType.CheckBoolean) {
      panelField = (
        <div
          key={idx}
          className={`ocs-mr-12 d-flex flex-column ${
            prevValues ? "justify-content-between" : "justify-content-end"
          } `}
        >
          {prevValues && (
            <div className="ocs-field-container ocs-mb-6">
              <label>{field.caption}</label>
              <p className={"ocs-field-readonly"}>
                {prevValues[field.name] ? "Yes" : "No"}
              </p>
            </div>
          )}
          <CheckBooleanField
            name={field.name}
            value={values[field.name]}
            caption={field.caption}
            onChange={onFieldChange}
          />
        </div>
      )
    }

    if (field.type === FieldType.DatePicker) {
      panelField = (
        <div key={idx} className="ocs-w-100 ocs-mr-12">
          {prevValues && (
            <div className="ocs-field-container ocs-mb-6">
              <label>{field.caption}</label>
              <p className={"ocs-field-readonly"}>
                {formatDateShortwYear(new Date(prevValues[field.name]))}
              </p>
            </div>
          )}
          <DatePickerField
            required={field.required}
            touched={touched}
            displayFormat="ddMMMyyyy"
            isEmpty={values[field.name] === null}
            name={field.name}
            caption={prevValues ? null : field.caption}
            value={values[field.name]}
            onChange={onFieldChange}
          />
        </div>
      )
    }

    if (field.type === FieldType.Time) {
      panelField = (
        <div key={idx} className="ocs-w-60 ocs-mr-12">
          {prevValues && (
            <div className="ocs-field-container ocs-mb-6">
              <label>{field.caption}</label>
              <p className={"ocs-field-readonly"}>{prevValues[field.name]}</p>
            </div>
          )}
          <TimeField
            required={field.required}
            touched={touched}
            isEmpty={values[field.name] === null}
            name={field.name}
            caption={prevValues ? null : field.caption}
            value={values[field.name]}
            onChange={onFieldChange}
          />
        </div>
      )
    }

    return panelField
  })

  return (
    <CustomModal
      isOpen
      onClose={(e: BtnEvent) => {
        if (e.currentTarget === e.target) {
          onCancel()
        }
      }}
      title={title}
      ctaText={CTAText}
      onCallback={onCTAClick}
      size="auto"
      onToggle={onCancel}
    >
      <form className="ocs-form">
        <div className="d-flex ocs-m-12">{panelFields}</div>
      </form>
    </CustomModal>
  )
}

export default DataEditPanel

